import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { responseToState } from '~/mappers';

function filter(name, param, id, param2, id2) {
    var filter = name.filter(function (val, i) {
        return val[param] === id;
    });

    if (id2 === undefined && param2 === undefined) return filter;

    return filter.filter(function (val, i) {
        return val[param2] === id2;
    });
}

export default {
    namespaced: true,
    state: function state() {
        return {
            departments: [],
            typeRoads: [],
            typeUrbanizations: [],
            provinces: [],
            districts: []
        };
    },

    getters: {
        departments: function departments(state) {
            return state.departments;
        },
        typeRoads: function typeRoads(state) {
            return state.typeRoads;
        },
        typeUrbanizations: function typeUrbanizations(state) {
            return state.typeUrbanizations;
        }
    },
    mutations: {
        setDepartments: function setDepartments(state, departments) {
            state.departments = responseToState(departments, 'departmentId', 'departmentDescription');
        },
        setTypeRoads: function setTypeRoads(state, typeRoads) {
            state.typeRoads = responseToState(typeRoads, 'typeRoadId', 'typeRoadDescription');
        },
        setTypeUrbanizations: function setTypeUrbanizations(state, typeUrbanizations) {
            state.typeUrbanizations = responseToState(typeUrbanizations, 'typeUrbanizationId', 'typeUrbanizationDescription');
        },
        setProvince: function setProvince(state, provinces) {
            state.provinces = provinces;
        },
        setDistricts: function setDistricts(state, districts) {
            state.districts = districts;
        }
    },
    actions: {
        initialLoad: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, master) {
                var commit = _ref.commit;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                commit('setDepartments', master.result.department);
                                commit('setTypeRoads', master.result.typeRoad);
                                commit('setTypeUrbanizations', master.result.typeUrbanization);
                                commit('setProvince', master.result.province);
                                commit('setDistricts', master.result.district);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function initialLoad(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return initialLoad;
        }(),
        getProvince: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, _ref4) {
                var state = _ref3.state;
                var departmentId = _ref4.departmentId;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', _Promise.resolve(responseToState(state.provinces.filter(function (p) {
                                    return p.departmentId === departmentId;
                                }), 'provinceId', 'provinceDescription')));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getProvince(_x3, _x4) {
                return _ref5.apply(this, arguments);
            }

            return getProvince;
        }(),
        getDistrict: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6, _ref7) {
                var state = _ref6.state;
                var departmentId = _ref7.departmentId,
                    provinceId = _ref7.provinceId;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt('return', _Promise.resolve(responseToState(state.districts.filter(function (d) {
                                    return d.departmentId === departmentId && d.provinceId === provinceId;
                                }), 'districtId', 'districtDescription')));

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getDistrict(_x5, _x6) {
                return _ref8.apply(this, arguments);
            }

            return getDistrict;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/store/geolocation.js
// module id = ./src/store/geolocation.js
// module chunks = 34